// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EUMe","tabsBox":"styles_tabsBox__npreL","createButton":"styles_createButton__4hrV5"};